export default {
  filters: [],
  pagination: {},
  filter: {}
}
